import { render, staticRenderFns } from "./MemoEditor.vue?vue&type=template&id=05c46cf3"
import script from "./MemoEditor.vue?vue&type=script&lang=js"
export * from "./MemoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports